import React from 'react';
import { MAINTENANCE_CONFIG } from '../config/maintenance';

const MaintenanceNotice = ({ feature, children }) => {
  if (!MAINTENANCE_CONFIG.isMaintenanceMode) {
    return children;
  }

  const isAllowed = MAINTENANCE_CONFIG.allowedFeatures[feature];
  
  if (isAllowed) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Maintenance Icon */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-orange-100 rounded-full mb-4">
            <svg className="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 7.586V5L8 4z" />
            </svg>
          </div>
        </div>

        {/* Maintenance Title */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          {MAINTENANCE_CONFIG.maintenanceInfo.title}
        </h1>

        {/* Maintenance Message */}
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          {MAINTENANCE_CONFIG.maintenanceInfo.message}
        </p>

        {/* Estimated Time */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <div className="flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-lg font-semibold text-gray-900">Estimated completion time</span>
          </div>
          <span className="text-2xl font-bold text-green-600">
            {MAINTENANCE_CONFIG.maintenanceInfo.estimatedTime}
          </span>
        </div>

        {/* Available Features */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* Available Features */}
          <div className="bg-green-50 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-green-800 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Available Features
            </h3>
            <ul className="space-y-2">
              {MAINTENANCE_CONFIG.maintenanceInfo.availableFeatures.map((feature, index) => (
                <li key={index} className="text-green-700 flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* Unavailable Features */}
          <div className="bg-red-50 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-red-800 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Temporarily Unavailable
            </h3>
            <ul className="space-y-2">
              {MAINTENANCE_CONFIG.maintenanceInfo.unavailableFeatures.map((feature, index) => (
                <li key={index} className="text-red-700 flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Back to Home Button */}
        <button
          onClick={() => window.location.href = '/'}
          className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          Return to Home
        </button>

        {/* Contact Information */}
        <div className="mt-8 text-gray-500">
          <p>For urgent medical consultations, please call:</p>
          <a href="tel:+911234567890" className="text-green-600 font-semibold hover:text-green-800">
            +91 123 456 7890
          </a>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceNotice;
